module.exports = __webpack_public_path__ + "static/parade-2020-house04-d0ec95d8352be9c844b2dc264b2acab6.jpg";